import { LocalStorageKeys } from '@containers/App';
import { StatusProcess } from '@helpers/Enums';
import Ticket from '@interfaces/ehss/ticket';
import Taskflow from '@interfaces/ITaskflow';
import { BaseProcess as Process } from '@interfaces/Process';
import TaskValue from '@interfaces/task-value';
import SchedulingService from '@services/graphQLSchedulingService';
import TicketService from '@services/TicketEvent';
import IOT from '@src/helpers/_iot';
import { Routes } from '@src/helpers/_routes';
import I18n from '@src/i18n';
import { Avatar, Badge, Dropdown, Menu } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';

import styled, { Theme } from '../../styled-components';
import { safePropertieRetrieve } from '@src/helpers/validation/ObjectValidator';

type PropType = {
    activeUnitId: string,
    activePillarId: string
    user?: any
    shouldUpdateNotifications: boolean
    updateNotifyContent: Function,
    updateNotificationVar: any,
    updateNotification: any
};

type StateType = {
    allTickets?: any[];
    myTickets?: any[];
    aleradyBackOneTime?: boolean;
    alertAmount: number;
    alertsData?: Ticket[];
    alertTotal: number;
    canEndTask: boolean;
    curOffset?: string;
    curProcess?: Process;
    curSelectsWeights: number;
    curTask?: any;
    curTaskflow?: Taskflow;
    curTaskId: number;
    curTaskRegisters: TaskValue[];
    curTaskValue?: any;
    curTicket?: Ticket;
    downloadingTaskFlow: boolean;
    executingTask: boolean;
    isLoading: boolean;
    onCancelClosingStep: number;
    resetValue?: boolean;
    sendingTaskflowRegister: boolean;
    showExecutingFooter: boolean;
    startAt: number;
    stepToStart: number;
    taskFlowFinished: boolean;
    ticketData: any[];
    localTicket: any;
    processes: any;
};

class NotifyAlertComponent extends React.Component<PropType, StateType> {
    private unitId: string = this.props.activeUnitId;
    private _ticketService: TicketService = new TicketService();
    private _schedulingService: any = new SchedulingService();

    state = {
        allTickets: [],
        myTickets: [],
        isLoading: true,
        alertAmount: 0,
        alertTotal: 0,
        alertsData: [],
        curOffset: undefined,
        executingTask: false,
        showExecutingFooter: false,
        curTicket: undefined,
        curProcess: undefined,
        curTaskflow: undefined,
        curTask: undefined,
        curTaskId: 0,
        aleradyBackOneTime: false,
        curTaskValue: undefined,
        resetValue: false,
        curSelectsWeights: 0,
        canEndTask: false,
        downloadingTaskFlow: false,
        taskFlowFinished: false,
        stepToStart: 1,
        onCancelClosingStep: 1,
        curTaskRegisters: [],
        startAt: 0,
        sendingTaskflowRegister: false,
        ticketData: [],
        localTicket: localStorage.getItem(LocalStorageKeys.TICKETID) || '',
        processes: []
    };

    componentDidMount() {
        this.initialData()
    }

    shouldComponentUpdate(nextProps: any, nextState: any) {
        if (this.props.updateNotificationVar !== nextProps.updateNotificationVar || nextProps.updateNotificationVar === 'initial') {
            const update = async () => {
                await this.getInitialData(nextProps)
            }
            update()
            return true
        }
        return false
    }

    initialData = async () => {
        await Promise.all([this.getOldFormatAlerts(true), this.getnewFormatAlerts()])
        this.mergeAlerts()
    }

    connectToIot = async () => {
        if (this.props.activeUnitId !== undefined) {
            IOT.connect().then((e: any) => {
                const topicToListen = `evt_1_${this.unitId}`;
                console.log('iot connect', topicToListen)
                IOT.subscribe(topicToListen);
                IOT.onReceive.on(topicToListen, e => {
                    this.receiveNewTicket(e, this.state.alertsData);
                    console.log('====>', e)
                });
            });
        }
    }

    receiveNewTicket = async (ticketChanged: any, myTickets: any[]) => {
        await this.getAlertsToDo(true);
    }
    
    UNSAFE_componentWillReceiveProps(nextProps: any){
        this.getInitialData(nextProps);
    }

    getInitialData = async (nextProps: any) => {
        if (safePropertieRetrieve(nextProps, 'shouldUpdateNotifications')) {
            const { updateNotifyContent } = this.props
            await Promise.all([this.getOldFormatAlerts(true), this.getnewFormatAlerts()])
            this.mergeAlerts();
            updateNotifyContent(false);
        }
    }
    
    getnewFormatAlerts = async () => {
        const { id } = this.props.user
        const schedules = await this._schedulingService.getScheduleByUser(id, [StatusProcess.PENDENT, StatusProcess.IN_PROGRESS]);
        if(schedules.data && schedules.data.getSchedulesByUser){
            const { getSchedulesByUser } = schedules.data;
            const processes = [];
            for(let schedule of getSchedulesByUser){
                const newDate = new Date(schedule.from)
                const finalDate = newDate.toLocaleString('pt-BR')

                const process = Object.assign({}, schedule.process, { 
                    schedulerId: schedule.id,
                    scheduleTitle: schedule.title,
                    processName: schedule.process.name, 
                    user: this.props.user.name,
                    from: finalDate,
                    processStatus: schedule.status,
                    tags: schedule.tags || {}
                });

                processes.push(process);
            }
            this.setState({ processes })
        }
        
    }
    
    getOldFormatAlerts = async (reset: boolean) => {
        if (this.unitId.length === 0) {
            return;
        }

        this.setState({ isLoading: true });

        if (reset) {
            this.setState({
                curOffset: undefined
            });
        }

        try {
            const data: any = await this._ticketService.pagingMeProcess({ limit: 9999, status: StatusProcess.PENDENT, unit: this.unitId }, ['id', 'ticketId', 'label', 'workflowEvent.eventId', 'workflowEvent.id']);
            let newAlertsData: any[] = [];

            let events: any = []
            for (let ticket of data.items) {
                let event = {
                    ticketId: ticket.ticketId,
                    eventId: ticket.workflowEvent.eventId,
                    processId: ticket.workflowEvent.id,
                    label: ticket.label
                }
                events.push(event)
            }

            this.setState({ ticketData: events })

            if (!reset) {
                newAlertsData = this.state.myTickets || [];
            }
            newAlertsData = newAlertsData.concat(events);

            let totalAlerts: number = 0;
            if (newAlertsData !== undefined) {
                totalAlerts = data.count;
            }

            this.setState({
                isLoading: false,
                myTickets: newAlertsData,
                alertAmount: data.count,
                alertsData: newAlertsData,
                curOffset: data.offset,
                alertTotal: totalAlerts
            });
        } catch (error) {
            console.warn(error);
            this.setState({
                isLoading: false,
            });
        }
    };

    mergeAlerts = async () => {
        const { processes, myTickets } = this.state

        const mergedAlerts = processes.length > myTickets.length ? myTickets.concat(processes) : processes.concat(myTickets);
        const finalAlert = mergedAlerts.map((alert: any) => {
            let pathName = alert.ticketId ? `${Routes.executionprocess}/${alert.ticketId}/process/${alert.processId}` : `${Routes.executionprocess}/newProcessExecution`
            let version = alert.ticketId ? 'old' : 'new'
            const newAlert = Object.assign({}, alert, { pathName, version });

            return newAlert;
        })

        this.setState({processes: finalAlert, alertTotal: finalAlert.length})
    }

    loadMoreAlerts() {
        this.getOldFormatAlerts(false);
    }

    formatHTML(label: any) {
        return { __html: label };
    }

    clickLink = async (myticket: any) => {
        localStorage.setItem(LocalStorageKeys.TICKETID, myticket);
        console.log('myTicket', myticket)
    }

    render(): JSX.Element {
        const {
            alertTotal,
            processes
        } = this.state;

        let menuOverlay: JSX.Element;

        if (processes && processes.length > 0) {
            const ticket: any = processes.map((item: any, index: any) => {
                if(item.version === 'old'){
                    return (
                        <Menu.Item key={item.eventId + index}>
                            <div onClick={() => this.clickLink(item.id)}>
                                <Link to={item.pathName} dangerouslySetInnerHTML={this.formatHTML(item.label)} />
                            </div>
                        </Menu.Item>
                    )
                }
                else {
                    const isEatonProcess = item.id === 'wLWM9-b_Q' || item.id === 'HXedq_YcI' || item.id === 'RzF0JS1TK'

                    return (
                        (
                          <Menu.Item key={`${item.id}-${item.from}`}>
                            <Link 
                                to={{
                                    pathname: item.pathName,
                                    state:{ newWorkflow: true, process: item }
                                }}>
                                  <div className="notification-wrapper" onClick={() => this.clickLink(item.id)}>
                                <div className="upper-part">
                            <span className="process"><span style={{fontWeight: 'bold'}}>{I18n.l('labels.processTitle')}</span>: {item.name}</span>
                                    <span className="status">{item.status}</span>
                                </div>
                                <div className="lower-part">
                                    <span className="deadline"><span style={{fontWeight: 'bold'}}>{I18n.l('label.deadline')}</span>: {item.from}</span>
                                </div>

                                    {isEatonProcess && item.tags && (<>
                                    <div className="lower-part">
                                    <span className="deadline"><span style={{fontWeight: 'bold'}}>{I18n.l('label.workshopName')}</span>: {item.tags.oficina}</span>
                                    </div>
                                    <div className="lower-part">
                                        <span className="deadline"><span style={{fontWeight: 'bold'}}>{I18n.l('label.workshopScore')}</span>: {item.tags.nivelAvaliacao}</span>
                                    </div>
                                    {item.tags.notaFiscal && (<div className="lower-part">
                                        <span className="deadline"><span style={{fontWeight: 'bold'}}>{I18n.l('label.invoice')}</span>: {item.tags.notaFiscal}</span>
                                    </div>)}
                                </>)}
                                   </div>  
                                </Link>
                          </Menu.Item>
                        )
                    )
                }
            })
            menuOverlay = (
                <NotifyAlertBox>
                    <Menu className="goepik-notify-box" selectable={true}>
                        {ticket}
                    </Menu>
                </NotifyAlertBox>
            )
        } else {
            menuOverlay = (
                <NotifyAlertBox>
                </NotifyAlertBox>
            )
        }

        return (
            <div>
                <Dropdown trigger={['click']} overlay={menuOverlay}>
                    <div className="goepik-notify-icon">
                        <span style={{ marginRight: 24 }}>
                            <Badge count={alertTotal} overflowCount={999}><Avatar shape="circle" icon="exclamation" /></Badge>
                        </span>
                    </div >
                </Dropdown >
            </div>
        );
    }
};

const NotifyAlertBox = styled.div`
    .goepik-notify-box{
        padding: 10px;
        min-width: 400px;
        max-width: 500px;
        height: 600px;
        overflow-y: auto;
        border-radius: 7px;
        box-shadow: 1px 1px 20px ${Theme.standard.lightGray || '#e0e0e0'};

        p{
            color: #5d5d5d;
        }


        .notification-wrapper{
            display: flex;
            flex-direction: column;
            width: 100%;
            box-sizing: border-box;
            color: #5d5d5d;

            .process{
                    font-size: 1.2em;
                }
            span{
                .deadline{
                    font-weight: 600;
                }
                :nth-child(2){
                    display: block;
                    margin-top: -4%;
                }
            }

            .lower-part{
                display: flex;
                align-items: flex-end;
                justify-content: flex-start;
            }
        }
        .ant-menu-item{
            height: auto;
            white-space: normal;
        }

        .goepik-information-title{
            cursor:initial!important;
        }

        .goepik-information-title:hover {
            background-color: white};
        }
    }

    .ant-menu-item:hover {
        background-color: ${Theme.standard.lightGray2 || '#f3f3f3'};
        cursor:pointer;
    }

    .goepik-text-gray{
        font-weight: 900;
        color: ${Theme.standard.gray}!important;
    }

    p {
        line-height: initial;
    }

    .goepik-no-padding{

        .ant-modal-body{
            padding:0!important;
        }
    }

    .goepik-execution-body{

        .execution-body{
            padding: 24px 24px 0 24px!important;
        }
        .goepik-score-text{
            text-align: center;
            font-weight: 900;
            font-size: -webkit-xxx-large;
        }

        .goepik-execution-close{
            margin-top: 5em;
            text-align: center;
        }

        .goepik-score-text{
            text-align: center;
            font-weight: 900;
            font-size: -webkit-xxx-large;
        }

        .goepik-execution-footer{
            border-top-style: solid;
            border-top-width: 1.0px;
            border-top-color: ${Theme.standard.gray};
            padding: 0 24px 20px 24px;
            min-height: 60px;

        }

        .goepik-execution-footer-left{
            margin-top: 1em;
            position: absolute;
            left: 1em;
        }

        .goepik-execution-footer-right{
            margin-top: 1em;
            position: absolute;
            right: 1em;
        }
    }
`;

export default NotifyAlertComponent;
